import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  width: 100vw;
  position: relative;
  margin: 0 auto 0 auto;
  background-color: ${colors.neutralLightest};
  border-top: 20px solid ${colors.neutralLightest};
  border-bottom: 20px solid ${colors.neutralLightest};
  .PhotoCollage_listWrapper {
    width: 100%;
    max-width: 2200px;
    margin: -30px auto 0 auto;
    @media (min-width: 2000px) {
      position: relative;
      padding: 60px 0 120px 0;
      margin: -60px auto 0 auto;
    }
  }
  .PhotoCollage_list {
    list-style: none;
    height: calc(60vw + 10px);
    position: relative;
    z-index: 1;
    display: block;
    transform: none !important;
    transition: none;
    @media (min-width: 2000px) {
      height: calc(45vw + 10px);
    }
  }
  .PhotoCollage_listItem {
    position: absolute;
    background-position: center center;
    background-size: cover;
  }
  .PhotoCollage_listItem.PhotoCollage_listItem01 {
    width: calc(50% - 5px);
    height: 40vw;
    left: 0;
    top: 0;
    border-left: 0;
    @media (min-width: 2000px) {
      height: 30vw;
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem02 {
    width: calc(25% - 10px);
    height: calc(20vw - 5px);
    left: calc(50% + 5px);
    top: 0;
    border-right: 0;
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem03 {
    width: calc(25% - 5px);
    height: calc(20vw - 5px);
    left: calc(75% + 5px);
    top: 0;
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem04 {
    width: calc(25% - 10px);
    height: calc(20vw - 5px);
    left: calc(50% + 5px);
    top: calc(20vw + 5px);
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
      top: calc(15vw + 5px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem05 {
    width: calc(25% - 5px);
    height: calc(20vw - 5px);
    left: calc(75% + 5px);
    top: calc(20vw + 5px);
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
      top: calc(15vw + 5px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem06 {
    width: calc(25% - 5px);
    height: calc(20vw - 5px);
    left: 0;
    top: calc(40vw + 10px);
    border-right: 0;
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
      top: calc(30vw + 10px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem07 {
    width: calc(25% - 10px);
    height: calc(20vw - 5px);
    left: calc(25% + 5px);
    top: calc(40vw + 10px);
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
      top: calc(30vw + 10px);
    }
  }
  .PhotoCollage_listItem.PhotoCollage_listItem08 {
    width: calc(50% - 5px);
    height: calc(20vw - 5px);
    left: calc(50% + 5px);
    top: calc(40vw + 10px);
    border-left: 0;
    @media (min-width: 2000px) {
      height: calc(15vw - 5px);
      top: calc(30vw + 10px);
    }
  }
  .PhotoCollage_mobileButtonsWrapper {
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100vw;
    @media (min-width: 600px) {
      display: none;
    }
  }
  .PhotoCollage_mobileButton {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: 0;
    background: white;
    &:focus {
      outline: none;
    }
  }
  .PhotoCollage_mobileButtonPrev {
    transform: rotateZ(180deg);
  }
  .PhotoCollage_mobileButtonNext {
    transform: none;
  }
`;


function PhotoCollage({ content }) {
  return (
    <div className={styles} id="PhotoCollage">
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div id="PhotoCollage">
        <div className="PhotoCollage_listWrapper">
          <ul className="PhotoCollage_list">
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem01"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_1.contentUrl'), { width: 1000, height: 1000 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem02"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_2.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem03"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_3.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem04"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_4.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem05"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_5.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem06"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_6.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem07"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_7.contentUrl'), { width: 620, height: 620 })})` }}
            />
            <li
              className="PhotoCollage_listItem PhotoCollage_listItem08"
              style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image_8.contentUrl'), { width: 1000, height: 1000 })})` }}
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

PhotoCollage.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PhotoCollage;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PhotoCollage.section.js